import { render, staticRenderFns } from "./configTable.vue?vue&type=template&id=c5d0f6f0&scoped=true"
import script from "./configTable.vue?vue&type=script&lang=js"
export * from "./configTable.vue?vue&type=script&lang=js"
import style0 from "./configTable.vue?vue&type=style&index=0&id=c5d0f6f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d0f6f0",
  null
  
)

export default component.exports